import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, Tooltip } from "antd";
import { Row, Form, Input, Col, Select, Collapse, Dropdown, Menu } from "antd";

import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
// import FooterDashboard from "../common/FooterDashboard/FooterDashboard";
import { MinusCircleTwoTone, PlusCircleTwoTone, MoreOutlined, EditOutlined, ClearOutlined, FundViewOutlined, FileDoneOutlined } from "@ant-design/icons";
import QuestionnairesApi from "../common/Apis/QuestionnairesApi";
import ProductionApi from "../common/Apis/ProductionApi";
import AddTempHotHold from "../common/Models/HotHold/AddTemp";
import AddWaste from "../common/Models/Waste/AddWaste";
import StockLevel from "../common/Models/AfterCook/StockLevel";
import HotHoldApi from "../common/Apis/HotHoldApi";
import StockLevelApi from "../common/Apis/StockLevelApi";
import RecipeApi from "../common/Apis/RecipeApi";
import StorageListApi from "../common/Apis/StorageListApi";
import jsPDF from "jspdf";
import EmptyBox from "../common/CommonUI/EmptyBox";
import Pagination from "../common/Pagination/Pagination"; 
import "../common/Pagination/Pagination.css"; 

const HotHold = () => {
    const { Content } = Layout;
    const [formadd2] = Form.useForm();
    const { Panel } = Collapse;
    const [HotHold, setHotHold] = React.useState([]);
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));


    const [PaginatePage, setPaginatePage] = useState(0);
    const [PaginatetotalPages, settotalPages] = useState(null);
    const [PaginateLimit, setPaginateLimit] = useState(10);
    const [FilterEnable, setFilterEnable] = useState(true);
    const [totalElements, setTotalElements] = useState(0);

    const [formPaginate] = Form.useForm();
    formPaginate.setFieldsValue({
        paginate: PaginateLimit,
    });
    const handlesetPaginateLimit = (value) => {
        setPaginateLimit(value);
        setCurrentPage(1);
        formPaginate.setFieldsValue({
            paginate: value,
        });



        if (FilterEnable) {
            HotHoldApi.ListhotHold(0, value)
                .then((response) => {
                    settotalPages(response.totalPages);
                    setHotHold(response.payloadDto);
                    setTotalElements(response.totalElements);

                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            let singleLineString = filterRecipe
                .map((obj) => {
                    if (obj.answerType === "%") {
                        return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                    } else if (obj.answerType === "=") {
                        return `${obj.title}${obj.answerType}${obj.name}`;
                    } else {
                        return `${obj.title}=BETWEEN${createDateTimestamp(
                            obj.answerType
                        )}AND${createDateTimestamp(obj.name)}`;
                    }
                })
                .join("&");

            let filderData = window.btoa(
                "componentCode=HOT_HOLD&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
                );
            QuestionnairesApi.FilterQuestionsetNext(filderData, 0, value)
                .then((response) => {
                    settotalPages(response.totalPages);
                    setHotHold(response.payloadDto);
                    setTotalElements(response.totalElements);

                })
                .catch((err) => { });
        }
    };
    const [currentPage, setCurrentPage] = useState(1);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        let pageNew = page - 1


        if (FilterEnable) {
            HotHoldApi.ListhotHold(pageNew, PaginateLimit)
                .then((response) => {
                    setPaginatePage(pageNew)
                    settotalPages(response.totalPages);
                    setHotHold(response.payloadDto);
                    setTotalElements(response.totalElements);

                })
                .catch((err) => {
                    console.log(err);
                });

        } else {

            let singleLineString = filterRecipe
                .map((obj) => {
                    if (obj.answerType === "%") {
                        return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                    } else if (obj.answerType === "=") {
                        return `${obj.title}${obj.answerType}${obj.name}`;
                    } else {
                        return `${obj.title}=BETWEEN${createDateTimestamp(
                            obj.answerType
                        )}AND${createDateTimestamp(obj.name)}`;
                    }
                })
                .join("&");

            let filderData = window.btoa(
                "componentCode=HOT_HOLD&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
                );
            QuestionnairesApi.FilterQuestionsetNext(filderData, pageNew, PaginateLimit)
                .then((response) => {
                    setPaginatePage(pageNew)
                    settotalPages(response.totalPages);
                    setHotHold(response.payloadDto);
                    setTotalElements(response.totalElements);

                })
                .catch((err) => { });
        }
    };

    const getReheatProcess = useCallback(() => {
        HotHoldApi.ListhotHold(PaginatePage, PaginateLimit).then((response) => {
            settotalPages(response.totalPages);
            setHotHold(response.payloadDto);
            setTotalElements(response.totalElements);

        })
            .catch((err) => {
                console.log(err);
            });
    }, []);
    const [isLoading, setIsLoading] = useState(false);
    const PageLoading = useCallback(() => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
    }, []);

    useEffect(() => {
        getReheatProcess();
        PageLoading();
        fetchFilterStorage();
    }, [PageLoading]);


    const handleRemovefilterProduction = (FiltergetProductionIndex) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction.splice(FiltergetProductionIndex, 1);
        setFilterRecipe(newfilterProduction);
        if (FiltergetProductionIndex == 0) {
            getReheatProcess();
        }
    };
    const handleClear = () => {
        setFilterEnable(true);
        getReheatProcess();
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
        setFilterRecipe([
            {
                title: "",
                answerType: "",
                name: "",
            },
        ]);
    };
    const formRef = useRef(null);

    const [filterRecipe, setFilterRecipe] = useState([
        {
            title: "",
            answerType: "",
            name: "",
        },
    ]);

    const handleAddfilterRecipe = () => {
        setFilterRecipe([
            ...filterRecipe,
            {
                title: "",
                answerType: "",
                name: "",
            },
        ]);
    };

    const handleSubmit = (data) => {
        setIsLoading(true);
        setFilterEnable(false);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
        let singleLineString = filterRecipe
            .map((obj) => {
                if (obj.answerType === "%") {
                    return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                } else if (obj.answerType === "=") {
                    return `${obj.title}${obj.answerType}${obj.name}`;
                } else {
                    return `${obj.title}=BETWEEN${createDateTimestamp(
                        obj.answerType
                    )}AND${createDateTimestamp(obj.name)}`;
                }
            })
            .join("&");

        let filderData = window.btoa(
            "componentCode=HOT_HOLD&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
            );
            
            QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
            .then((response) => {
                setCurrentPage(1);
                settotalPages(response.totalPages);
                setHotHold(response.payloadDto);
                setTotalElements(response.totalElements);

            })
            .catch((err) => { });
    };
    const createDateTimestamp = (Cdate) => {
        const date = new Date(Cdate);
        const unixTime = Math.floor(date.getTime());
        return unixTime;
    };
    const handleChangeTitle = (FiltergetproductionIndex, value) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction[FiltergetproductionIndex].title = value;
        setFilterRecipe(newfilterProduction);


        const fieldName = 'name' + FiltergetproductionIndex;
        const fieldName2 = 'nameto' + FiltergetproductionIndex;
        formadd2.setFieldsValue({
            [fieldName]: null,
            [fieldName2]: null,
        });

    };
    const handleChangeAnswertype = (FiltergetproductionIndex, value) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction[FiltergetproductionIndex].answerType = value;
        setFilterRecipe(newfilterProduction);
    };
    const handleChangeAnswertypeFilter = (FiltergetproductionIndex, value) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction[FiltergetproductionIndex].answerType = '=';
        newfilterProduction[FiltergetproductionIndex].name = value;
        setFilterRecipe(newfilterProduction);
    };

    const handleChangename = (FiltergetproductionIndex, value) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction[FiltergetproductionIndex].name = value;
        setFilterRecipe(newfilterProduction);
    };

    const paginatedData = HotHold;

    const [modalStockLevelVisible, setModalStockLevelVisible] = useState(false);
    const [modalStockLevelData, setModalStockLevelData] = useState("");
    const [AfterCookId, setAfterCookId] = useState("");
    const [StockLevelProducts, setStockLevelProducts] = React.useState();
    const [StockLevelIncreadiant, setStockLevelIncreadiant] = React.useState([]);

    const handleOpenStockLevelModal = (ProductionID) => {
        ProductionApi.SingleProduction(ProductionID)
            .then((response2) => {
                setAfterCookId(response2.payload);
                RecipeApi.SingleRecipe(response2.payload?.recipeDTO?.id)
                    .then((responseRecipe) => {
                        setStockLevelIncreadiant(responseRecipe?.payload?.ingredientsDTO)
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
        StockLevelApi.ListStockProduction(ProductionID)
            .then((response) => {
                setStockLevelProducts(response?.payload[0])

            })
            .catch((err) => {
                console.log(err);
            });

        setModalStockLevelVisible(true);
    };
    const handlEditeCloseModal = () => {
        setModalStockLevelVisible(false);
    };

    const [modalwasteVisible, setModalwasteVisible] = useState(false);
    const [modalwasteData, setModalwasteData] = useState("");

    const handleOpenWasteModal = (ProductionID) => {
        // HotHoldApi.SinglehotHold(ProductionID)
        //     .then((response) => {
        //         ProductionApi.SingleProduction(response?.payload?.productionDTO?.id)
        //             .then((response2) => {
        //                 setModalwasteData(response2.payload);
        //             })
        //             .catch((err) => {
        //                 console.log(err);
        //             });
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     });
        ProductionApi.SingleProduction(ProductionID)
            .then((response2) => {
                setAfterCookId(response2.payload);
                setModalwasteData(response2.payload);
                RecipeApi.SingleRecipe(response2.payload?.recipeDTO?.id)
                    .then((responseRecipe) => {
                        setStockLevelIncreadiant(responseRecipe?.payload?.ingredientsDTO)
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
        StockLevelApi.ListStockProduction(ProductionID)
            .then((response) => {
                setStockLevelProducts(response?.payload[0])

            })
            .catch((err) => {
                console.log(err);
            });
        setModalwasteVisible(true);
    };

    const handlwasteCloseModal = () => {
        setModalwasteVisible(false);
    };


    const [modalReheatVisible, setModalReheatVisible] = useState(false);
    const [modalTempHotHoldData, setModalTempHotHoldData] = useState("");

    const handleOpenHotHoldModal = (ProductionID) => {
        console.log("ProductionID", ProductionID);
        if (ProductionID != undefined) {
            HotHoldApi.SinglehotHold(ProductionID)
                .then((response) => {
                    setModalTempHotHoldData(response.payload);

                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            setModalTempHotHoldData(null);

        }

        setModalReheatVisible(true);
    };

    const handlReheatCloseModal = () => {
        setModalReheatVisible(false);
    };


    function convertTo12HourFormat(timeString) {
        if (!timeString) return '';

        const [hours, minutes] = timeString.split(':');
        let formattedTime = '';

        let formattedHours = parseInt(hours, 10);
        const ampm = formattedHours >= 12 ? 'PM' : 'AM';
        formattedHours = formattedHours % 12 || 12;

        const formattedMinutes = minutes.padStart(2, '0');

        formattedTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
        return formattedTime;
    }

    function formatTime3(time) {
        const timeNew = parseInt(time, 10);
        const options = { hour: "2-digit", minute: "2-digit" };
        const formattedTime = new Date(timeNew).toLocaleTimeString(
            "en-US",
            options
        );

        return formattedTime;
    }

    const handlePrintButtonClick2 = () => {
        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: [297, 210],
        });

        const fontSize = 10;


        let yPos = 35;
        doc.setFontSize(fontSize);

        const currentDate = new Date().toLocaleDateString();
        const currentTime = new Date().toLocaleTimeString();
        const promises = [];


        for (let i = 0; i < parseInt(PaginatetotalPages); i++) {
            if (FilterEnable) {
                promises.push(
                    HotHoldApi.ListhotHold(i, PaginateLimit).then((response) => {
                        doc.setFont('Poppins', 'bold');
                        doc.text(`Hot Hold`, 150, 10, { align: 'center' });
                        doc.setFont('Poppins', 'normal');
                        doc.setFontSize(10);
                        doc.text(`Date : ${currentDate}`, 10, 20);
                        doc.text(`Time : ${currentTime}`, 10, 25);
                        doc.setFontSize(fontSize);

                        // Draw table headers and borders
                        doc.setFont('Poppins', 'bold');
                        doc.text('Date', 15, yPos);
                        doc.text('Time', 40, yPos);
                        doc.text('Product Description', 60, yPos);
                        doc.text('Temp', 110, yPos);
                        doc.text('Batch Code', 125, yPos);
                        doc.text('Qty', 160, yPos);
                        doc.text('Storage Unit', 180, yPos);
                        doc.text('Hold by', 210, yPos);
                        doc.text('Corrective Action', 250, yPos);
                        doc.setFont('Poppins', 'normal');
                        doc.setLineWidth(0.1);
                        doc.rect(12, yPos - 5, 280, 10);
                        yPos += 10;


                        response.payloadDto.forEach(row => {
                            const date = formatDate(row?.createdDate);
                            const cookingTime = (row?.createdDate) ? formatTime3(row?.createdDate) : '';
                            const productionName = (row?.productionDTO?.productionName) ? row?.productionDTO?.productionName : row?.productionName;
                            const temp = (row?.temp !== "N/A") ? row?.temp + ' °C' : "N/A";
                            const batchCode = row?.productionDTO?.batchCode;
                            const oubd = row?.productionDTO?.quantity + " " + row?.productionDTO?.unit;
                            const sellByDate = (row?.storageDTO?.name);
                            const createdBy = row?.tenantDTO?.createdBy;
                            const allergenInfo = row?.correctiveAction;

                            doc.setFontSize(fontSize);

                            doc.text(date, 15, yPos);
                            doc.text(cookingTime, 40, yPos);
                            doc.text(productionName, 60, yPos);
                            doc.text(temp, 110, yPos);
                            doc.text(batchCode, 125, yPos);
                            doc.text(oubd, 160, yPos);
                            doc.text(sellByDate, 180, yPos);
                            doc.text(createdBy, 210, yPos);
                            const allergenLines = doc.splitTextToSize(allergenInfo, 40);
                            doc.text(allergenLines, 250, yPos);

                            const rowHeight = 10 * Math.max(allergenLines.length, 1);

                            if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
                                doc.addPage();
                                yPos = 35; // Reset yPos for the new page
                            } else {
                                doc.setLineWidth(0.1);
                                doc.rect(12, yPos - 5, 280, rowHeight);
                                yPos += rowHeight;
                            }
                        });

                        if (i === parseInt(PaginatetotalPages)) {
                            doc.addPage();
                            yPos = 35;
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
                );
            } else {

                let singleLineString = filterRecipe
                    .map((obj) => {
                        if (obj.answerType === "%") {
                            return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                        } else if (obj.answerType === "=") {
                            return `${obj.title}${obj.answerType}${obj.name}`;
                        } else {
                            return `${obj.title}=BETWEEN${createDateTimestamp(
                                obj.answerType
                            )}AND${createDateTimestamp(obj.name)}`;
                        }
                    })
                    .join("&");

                let filderData = window.btoa(
                    "componentCode=HOT_HOLD&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
                    );

                promises.push(
                    QuestionnairesApi.FilterQuestionsetNext(filderData, i, PaginateLimit).then((response) => {
                        doc.setFont('Poppins', 'bold');
                        doc.text(`Hot Hold`, 150, 10, { align: 'center' });
                        doc.setFont('Poppins', 'normal');
                        doc.setFontSize(10);
                        doc.text(`Date : ${currentDate}`, 10, 20);
                        doc.text(`Time : ${currentTime}`, 10, 25);
                        doc.setFontSize(fontSize);

                        // Draw table headers and borders
                        doc.setFont('Poppins', 'bold');
                        doc.text('Date', 15, yPos);
                        doc.text('Time', 40, yPos);
                        doc.text('Product Description', 60, yPos);
                        doc.text('Temp', 110, yPos);
                        doc.text('Batch Code', 125, yPos);
                        doc.text('Qty', 160, yPos);
                        doc.text('Storage Unit', 180, yPos);
                        doc.text('Hold by', 210, yPos);
                        doc.text('Corrective Action', 250, yPos);
                        doc.setFont('Poppins', 'normal');
                        doc.setLineWidth(0.1);
                        doc.rect(12, yPos - 5, 280, 10);
                        yPos += 10;


                        response.payloadDto.forEach(row => {
                            const date = formatDate(row?.createdDate);
                            const cookingTime = (row?.createdDate) ? formatTime3(row?.createdDate) : '';
                            const productionName = (row?.productionDTO?.productionName) ? row?.productionDTO?.productionName : row?.productionName;
                            const temp = (row?.temp !== "N/A") ? row?.temp + ' °C' : "N/A";
                            const batchCode = row?.productionDTO?.batchCode;
                            const oubd = row?.productionDTO?.quantity + " " + row?.productionDTO?.unit;
                            const sellByDate = (row?.storageDTO?.name);
                            const createdBy = row?.tenantDTO?.createdBy;
                            const allergenInfo = row?.correctiveAction;

                            doc.setFontSize(fontSize);

                            doc.text(date, 15, yPos);
                            doc.text(cookingTime, 40, yPos);
                            doc.text(productionName, 60, yPos);
                            doc.text(temp, 110, yPos);
                            doc.text(batchCode, 125, yPos);
                            doc.text(oubd, 160, yPos);
                            doc.text(sellByDate, 180, yPos);
                            doc.text(createdBy, 210, yPos);
                            const allergenLines = doc.splitTextToSize(allergenInfo, 40);
                            doc.text(allergenLines, 250, yPos);

                            const rowHeight = 10 * Math.max(allergenLines.length, 1);

                            if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
                                doc.addPage();
                                yPos = 35; // Reset yPos for the new page
                            } else {
                                doc.setLineWidth(0.1);
                                doc.rect(12, yPos - 5, 280, rowHeight);
                                yPos += rowHeight;
                            }
                        });

                        if (i === parseInt(PaginatetotalPages)) {
                            doc.addPage();
                            yPos = 35;
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
                );
            }


        }

        const reversedPromises = promises.map(promise =>
            promise.then(result =>
                new Promise(resolve =>
                    setTimeout(() => resolve(result), 0)
                )
            )
        );

        Promise.all(reversedPromises)
            .then(() => {
                window.open(doc.output('bloburl'), '_blank');
            })
            .catch((err) => {
                console.log(err);
            });

    };

    const renderTableRows = () => {
        if (paginatedData.length > 0) {
            return paginatedData.map((item) => (
                <tr key={item?.id} className="text-center">
                    <td style={{ width: "5%" }} className="pt-3 ">
                        {formatDate(item?.createdDate)}
                    </td>
                    <td style={{ width: "5%" }} className="pt-3 ">
                        {formatTime3(item?.createdDate)}
                    </td>
                    <td style={{ width: "10%" }} className="pt-3 ">
                        {(item?.productionDTO?.productionName) ? item?.productionDTO?.productionName : item?.productionName}
                    </td>
                    <td style={{ width: "5%" }} className="pt-3 ">
                        <div style={{
                            overflowX: 'auto',
                            overflowY: 'hidden',
                            whiteSpace: 'nowrap',
                            maxWidth: '200px',
                            marginBottom: '10px',
                            marginTop: '-3px',
                            padding: '0px 0px 20px',
                            display: 'block',
                            }}>
                            {item?.productionDTO?.batchCode}
                        </div>  
                    </td>
                    <td style={{ width: "5%" }} className="pt-3">
                        {item?.temp ? item?.temp + ' °C' : "N/A"}
                    </td>
                    <td style={{ width: "5%" }} className="pt-3 text-center">
                        {item?.productionDTO?.quantity} {item?.productionDTO?.unit}
                    </td>
                    <td style={{ width: "10%", textAlign: 'center' }} className="pt-3">
                        {item?.storageDTO?.name}
                        <p style={{ color: 'gray', fontSize: '14px' }}>{item?.storageDTO ? <>({item?.storageDTO?.temperatureMinInCelsius}°C - {item?.storageDTO?.temperatureMaxInCelsius}°C)</> : ''}</p>

                    </td>
                    <td style={{ width: "9%" }} className="pt-3">
                        {item?.createdBy}
                    </td>

                    <td style={{ width: "10%", textAlign: 'center' }} className="pt-3">
                        {item?.correctiveAction !== "N/A" &&
                            <Tooltip placement="top" title={(
                                <div>
                                    {item?.correctiveAction}
                                </div>
                            )}>
                                <FileDoneOutlined className="inforIcon" />
                            </Tooltip>
                        }
                    </td>

                    <td style={{ width: "4%" }}>

                        <div className="d-flex justify-content-center">
                            <Dropdown
                                overlay={
                                    <Menu>

                                        <Menu.Item
                                            key="Take"
                                            className={decodedToken?.permissions?.some(
                                                (permission) => permission?.authority === 'ADD_HOT_HOLD'
                                            ) ? '' : 'd-none'}
                                            onClick={() => handleOpenHotHoldModal(item.id)}
                                        >
                                            <EditOutlined /> Take Temp
                                        </Menu.Item>

                                        <Menu.Item
                                            key="Stock"
                                            className={decodedToken?.permissions?.some(
                                                (permission) => permission?.authority === 'ADD_STOCK_LEVEL'
                                            ) ? '' : 'd-none'}
                                            onClick={() => handleOpenStockLevelModal(item?.productionDTO?.id)}>
                                            <FundViewOutlined /> Stock Level
                                        </Menu.Item>

                                        <Menu.Item
                                            key="Waste"
                                            className={decodedToken?.permissions?.some(
                                                (permission) => permission?.authority === 'ADD_PRODUCTION_WASTE'
                                            ) ? '' : 'd-none'}
                                            onClick={() => handleOpenWasteModal(item?.productionDTO?.id)}>
                                            <ClearOutlined /> Waste
                                        </Menu.Item>



                                    </Menu>
                                }
                                trigger={["click"]}
                                placement="bottom"
                            >
                                <div className="action-circle">
                                    <MoreOutlined />
                                </div>
                            </Dropdown>
                        </div>
                    </td>
                </tr>
            ));
        } else {
            return (<>
                <tr className="text-center EmptyTable">
                    <td colSpan={10} className="text-center ">
                        <EmptyBox />
                        <br />
                    </td>
                </tr></>
            );
        }
    };

    function formatDate(date) {
        const dateNew = parseInt(date, 10);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(dateNew).toLocaleDateString(
            "en-US",
            options
        );

        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }


    const [FilterStorage, setFilterStorage] = useState([]);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);


    const fetchFilterStorage = async () => {
        try {
            StorageListApi.ListStorage(page, 20)
                .then((response) => {
                    // setDepartments(response?.payloadDto);
                    setTotalPageNew(response.totalPages);
                    setFilterStorage(prevDepartments => [...prevDepartments, ...response?.payloadDto]);

                    setPage(prevPage => prevPage + 1);

                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (error) {
        } finally {
        }
    };
    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        const nearBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1; // Add a small buffer
        if (bottom || nearBottom) {
            if (TotalPageNew > page) {
                fetchFilterStorage();
            }
        }
    };

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader onPrintResponse2={handlePrintButtonClick2} />
                {isLoading && (
                    <div className="spinner-overlay" id="spinnerOverlay">
                        <div className="spinner"></div>
                    </div>
                )}
                <div
                    style={{
                        padding: "20px",
                        paddingBottom: "5px",
                    }}
                >
                    <Form
                        ref={formRef}
                        form={formadd2}
                        name="nest-messages"
                        layout="vertical"
                        className="FormClass FilterForm"
                        onFinish={handleSubmit}
                    >
                        <>
                            <Collapse>
                                <Panel
                                    header={
                                        <h5 className="mb-0">
                                            <b>Filter</b>
                                        </h5>
                                    }
                                    key="1"
                                >
                                    {filterRecipe.map((input, filterProductionIndex) => (
                                        <div key={filterProductionIndex}>
                                            <Row gutter={24} className="pt-2">
                                                <Col lg={5} md={5} className="px-1">
                                                    <Form.Item
                                                        name={`title${filterProductionIndex}`}
                                                        className="text-lable"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please Select",
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            className="control-Select"
                                                            placeholder="Filter By"
                                                            value={input.title}
                                                            onChange={(value) =>
                                                                handleChangeTitle(filterProductionIndex, value)
                                                            }
                                                            options={[

                                                                {
                                                                    value: "hotHoldDate",
                                                                    label: "Added Date",
                                                                },
                                                                {
                                                                    value: "production.productionName",
                                                                    label: "Product description",
                                                                },
                                                                {
                                                                    value: "production.batchCode",
                                                                    label: "Batch Code",
                                                                },
                                                                {
                                                                    value: "storage.id",
                                                                    label: "Storage Unit",
                                                                },
                                                            ]}
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                {filterRecipe[filterProductionIndex].title ==
                                                    "hotHoldDate" ? (
                                                    <>
                                                        <Col lg={4} md={4} className="px-1">
                                                            <Form.Item
                                                                name={`nameto${filterProductionIndex}`}
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please Select Start Date.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    type="date"
                                                                    placeholder="Filter By"
                                                                    onChange={(e) =>
                                                                        handleChangeAnswertype(
                                                                            filterProductionIndex,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className="control-input"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </>
                                                ) : filterRecipe[filterProductionIndex].title === "storage.id" ? (
                                                    <>
                                                        <Col lg={6} md={6} className="px-1">
                                                            <Form.Item
                                                                name={`nameto${filterProductionIndex}`}
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please Select Start Date.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Select
                                                                    showSearch
                                                                    className="control-Select mb-1"
                                                                    placeholder="Select Storage Unit"
                                                                    onPopupScroll={handleScroll}
                                                                    onChange={(value) =>
                                                                        handleChangeAnswertypeFilter(
                                                                            filterProductionIndex,
                                                                            value
                                                                        )
                                                                    }
                                                                    filterOption={(input, option) =>
                                                                        option.props.children.toLowerCase().includes(input.toLowerCase())
                                                                    }
                                                                >
                                                                    {FilterStorage.map((option, index) => (
                                                                        <Select.Option key={option.id} value={option.id}>
                                                                            {option.name}
                                                                        </Select.Option>
                                                                    ))}
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Col lg={4} md={4} className="px-1">
                                                            <Form.Item
                                                                name={`type${filterProductionIndex}`}
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please Select type.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Select
                                                                    className="control-Select mb-1"
                                                                    placeholder="Condition"
                                                                    onChange={(value) =>
                                                                        handleChangeAnswertype(
                                                                            filterProductionIndex,
                                                                            value
                                                                        )
                                                                    }
                                                                    options={[
                                                                        { value: "%", label: "Matches with" },
                                                                        {
                                                                            value: "=",
                                                                            label: "Equals to",
                                                                        },
                                                                    ]}
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </>
                                                )}


                                                {filterRecipe[filterProductionIndex].title ==
                                                    "hotHoldDate" ? (
                                                    <>
                                                        <Col lg={5} md={5} className="px-1">
                                                            <Form.Item
                                                                name={`name${filterProductionIndex}`}
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please Select End Date.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    type="date"
                                                                    onChange={(e) =>
                                                                        handleChangename(
                                                                            filterProductionIndex,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    placeholder="Text"
                                                                    className="control-input"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </>
                                                ) : filterRecipe[filterProductionIndex].title === "storage.id" ? (
                                                    <>

                                                    </>
                                                ) : (
                                                    <>
                                                        <Col lg={5} md={5} className="px-1">
                                                            <Form.Item
                                                                name={`name${filterProductionIndex}`}
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please enter Text.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    type="text"
                                                                    onChange={(e) =>
                                                                        handleChangename(
                                                                            filterProductionIndex,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    placeholder="Text"
                                                                    className="control-input"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </>
                                                )}


                                                <Col lg={8} md={10} className="px-1">
                                                    <Form.Item className="text-lable">
                                                        {filterProductionIndex == 0 ? (
                                                            <>
                                                                <Row gutter={23} className="mb-3">
                                                                    <Col span={2} className="mx-0">
                                                                        <Form.Item className="text-lable">
                                                                            <PlusCircleTwoTone
                                                                                onClick={handleAddfilterRecipe}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>

                                                                    <Col span={10}>
                                                                        <Button
                                                                            type="primary"
                                                                            htmlType="submit"
                                                                            className="btn btn-primary btn-save table-action icon-center "
                                                                        >
                                                                            Filter
                                                                        </Button>
                                                                    </Col>
                                                                    <Col span={10}>
                                                                        <Button
                                                                            type="reset"
                                                                            htmlType="reset"
                                                                            onClick={() => handleClear()}
                                                                            style={{ color: "#0b5ed7" }}
                                                                            className="btn btn-primary btn-back table-action icon-center"
                                                                        >
                                                                            Clear
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {" "}
                                                                <MinusCircleTwoTone
                                                                    onClick={() =>
                                                                        handleRemovefilterProduction(
                                                                            filterProductionIndex
                                                                        )
                                                                    }
                                                                />
                                                            </>
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    ))}
                                </Panel>
                            </Collapse>
                        </>
                    </Form>
                </div>
                <Content
                    className="form-content nav-content"
                    style={{
                        margin: "14px 16px 0",
                        padding: "30px",
                        background: "white",
                    }}
                >
                    <div>

                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                {/* <Button
                                    className={decodedToken?.permissions?.some(
                                        (permission) => permission?.authority === 'ADD_HOT_HOLD'
                                    ) ? 'btn btn-primary btn-save m-0 my-2' : 'd-none'}
                                    onClick={() => handleOpenHotHoldModal()}
                                >
                                    Add Hot Hold
                                </Button> */}
                                <Button
                                    type="primary"
                                    onClick={() => handleOpenHotHoldModal()}
                                    style={{
                                        display: decodedToken?.permissions?.some(
                                            permission => permission?.authority === 'ADD_HOT_HOLD'
                                        ) ? '' : 'none',
                                        height: 'auto',
                                        lineHeight: 'normal',
                                        alignItems: 'center',
                                        padding: '5px 24px',
                                    }}
                                >
                                    Add to hot hold
                                </Button>
                            </div>
                            <div>

                                <Form
                                    form={formPaginate}
                                >
                                    <Form.Item
                                        name="paginate"
                                        className="text-lable"
                                        style={{ width: '100px' }}
                                    >
                                        <Select
                                            className="control-Select"
                                            onChange={(value) => {
                                                handlesetPaginateLimit(value)
                                            }}
                                            options={[
                                                { value: 10, label: "10" },
                                                { value: 20, label: "20" },
                                                { value: 30, label: "30" },
                                                { value: 40, label: "40" },
                                                { value: 50, label: "50" },
                                            ]}
                                        />
                                    </Form.Item>
                                </Form>

                            </div>
                        </div>
                        <table className="table users-table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Production Name</th>
                                    <th>Batch Code</th>
                                    <th>Temp</th>
                                    <th className="text-end">Qty</th>
                                    <th className="text-center">Storage Unit</th>
                                    <th>Hold by</th>
                                    <th className="text-center">Corrective Action</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>{renderTableRows()}</tbody>
                        </table>

                        {paginatedData.length > 0 && (
                            <Pagination
                                currentPage={currentPage}
                                totalPages={PaginatetotalPages}
                                onPageChange={handlePageChange}
                                maxVisiblePages={5}
                                showPageInfo={true}
                                totalItems={totalElements}
                                pageSize={PaginateLimit}
                            />
                            )}

                    </div>
                </Content>

                {modalReheatVisible &&
                    <AddTempHotHold
                        visible={modalReheatVisible}
                        onClose={handlReheatCloseModal}
                        ProductctionDetails={modalTempHotHoldData}
                        hothold={true}
                    />
                }
                {modalwasteVisible &&
                    <AddWaste
                        visible={modalwasteVisible}
                        onClose={handlwasteCloseModal}
                        ProductionDetails={modalwasteData}
                        ingredientDetails={StockLevelIncreadiant}
                    />
                }
                {modalStockLevelVisible &&
                    <StockLevel
                        visible={modalStockLevelVisible}
                        onClose={handlEditeCloseModal}
                        afterCookId={modalStockLevelData}
                        StockLevelProducts={StockLevelProducts}
                        StockLevelIncreadiant={StockLevelIncreadiant}
                    />
                }

                {/* <FooterDashboard /> */}
            </Layout>
        </Layout>
    );
};

export default HotHold;
